//////LIBRARY//////
import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import Dropdown from '../../components/Ui/Dropdown'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { bindActionCreators } from 'redux'
import { statisticsActionCreators } from '../../store/actions'
import Theme from '../../theme/theme'
import { ActionWrapperElem, DatePickerFilterLabel } from '../../theme/GlobalCss'
import moment from 'moment/moment'
import UseDatePicker from '../../hooks/UseDatePicker'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'
import Button from '../../components/Ui/Buttons'
import Tooltip from '../../components/Tooltip/Tooltip'
import Export from '../../assets/icones/table/export-datas.svg'

//////STYLED//////

const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
export const FiltersWrapper = styled.div`
    flex-direction: column;
    display: flex;
	
`;

export const CalendarWrapper = styled.div`
    flex-direction: row;
    display: flex;
	margin: 20px;
`;

export const StatisticsWrapper = styled.div`
    display: flex;
    box-sizing: border-box;
`;

export const SalesChartsWrapper = styled.div`
    flex: 2;
	width: 400px;
    display: flex;
    overflow: hidden;
    min-width: 0;  /* Also prevent overflow here */
	z-index: 0;
`;

export const LineChartsWrapper = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: stretch;  /* Center charts vertically */
    gap: 16px;
    overflow: hidden;
    min-width: 0;  /* Also prevent overflow here */
`;

export const ChartsContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 90%;
`;

export const ChartsWrapper = styled.div`
    flex: 1;
    flex-direction: column;
    display: flex;
`;

export const KioskDataWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: stretch;  /* Center charts vertically */
    overflow: hidden;
    min-width: 0;  /* Also prevent overflow here */
`;

export const LeftPartWrapper = styled.div`
    //display: flex;
    //flex-direction: column;
    //justify-content: stretch;  /* Center charts vertically */
    //overflow: hidden;
    //min-width: 0;  /* Also prevent overflow here */
`;

const ExportWrapper = styled(ActionWrapperElem)`
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	align-items: center;
	justify-content: center;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`

const ExportButton = styled.img`
	width: 24px;
	height: 24px;
`

NoDataToDisplay(Highcharts);

const Statistics = (props) => {

	const {
		translations,
		userKioskPerimeter,
		statistics,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			statistics:  state.statistics.data.data,
		}),
		shallowEqual
	)

	// STATE

	const toUTC = d => {
		const [y, m, day] = d.split('-').map(Number);
		return Date.UTC(y, m - 1, day);
	};

	const [currentKiosk, setCurrentKiosk] = useState({
		kioskId: null
	})

	const [salesOptions, setSalesOptions] = useState({
		lang: {
			noData: translations['ref__no_data_statistics'] // FR
		},
		noData: {
			style: {
				align: 'center',
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#666'
			}
		},
		chart: {
			height: 350,
			width: 350,
			type: 'pie'
		},
		title: { text: translations['ref__sales_chart_statistics'] },
		series: [
			{ name: 'Sales', data: [] }
		],
		credits: {
			enabled: false
		}
	});

	const [averageVoltageOptions, setAverageVoltageOptions] = useState({
		lang: {
			noData: translations['ref__no_data_statistics']
		},
		noData: {
			style: {
				align: 'center',
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#666'
			}
		},
		title: { text: translations['ref__voltage_average_statistics'] },
		xAxis: {
			type: 'datetime',
			dateTimeLabelFormats: {
				day: '%d/%m/%Y',
				week: '%d/%m/%Y',
				month: '%m/%Y',
				year: '%Y',
			}
		},
		yAxis: [
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' (V)' },
				// Optional styling:
				// gridLineWidth: 1
			},
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' ' + translations?.['ref__filter_solar_panel_statistics'] + ' (V)' },
				opposite: true // puts the axis on the right side
				// gridLineWidth: 0 // optional: hide grid for the right axis
			}
		],
		series: [],
		credits: {
			enabled: false
		}
	})

	const [minVoltageOptions, setMinVoltageOptions] = useState({
		lang: {
			noData: translations['ref__no_data_statistics']
		},
		noData: {
			style: {
				align: 'center',
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#666'
			}
		},
		title: { text: translations['ref__voltage_min_statistics'] },
		xAxis: {
			type: 'datetime',
			dateTimeLabelFormats: {
				day: '%d/%m/%Y',
				week: '%d/%m/%Y',
				month: '%m/%Y',
				year: '%Y',
			}
		},
		yAxis: [
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' (V)' },
				// Optional styling:
				// gridLineWidth: 1
			},
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' ' + translations?.['ref__filter_solar_panel_statistics'] + ' (V)' },
				opposite: true // puts the axis on the right side
				// gridLineWidth: 0 // optional: hide grid for the right axis
			}
		],
		series: [],
		credits: {
			enabled: false
		}
	})

	const [maxVoltageOptions, setMaxVoltageOptions] = useState({
		lang: {
			noData: translations['ref__no_data_statistics']
		},
		noData: {
			style: {
				align: 'center',
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#666'
			}
		},
		title: { text: translations['ref__voltage_max_statistics'] },
		xAxis: {
			type: 'datetime',
			dateTimeLabelFormats: {
				day: '%d/%m/%Y',
				week: '%d/%m/%Y',
				month: '%m/%Y',
				year: '%Y',
			}
		},
		yAxis: [
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' (V)' },
				// Optional styling:
				// gridLineWidth: 1
			},
			{
				title: { text: translations?.['ref__voltage_statistics'] + ' ' + translations?.['ref__filter_solar_panel_statistics'] + ' (V)' },
				opposite: true // puts the axis on the right side
				// gridLineWidth: 0 // optional: hide grid for the right axis
			}
		],
		series: [],
		credits: {
			enabled: false
		}
	})

	const [bottleOptions, setBottleOptions] = useState({
		lang: {
			noData: translations['ref__no_data_statistics']
		},
		noData: {
			style: {
				align: 'center',
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#666'
			}
		},
		title: { text: translations['ref__bottles_statistics'] },
		xAxis: {
			type: 'datetime',
			dateTimeLabelFormats: {
				day: '%d/%m/%Y',
				week: '%d/%m/%Y',
				month: '%m/%Y',
				year: '%Y',
			}
		},
		yAxis: [
			{
				title: { text: translations?.['ref__filter_full_bottle_statistics'] + ' / ' +  translations?.['ref__filter_error_locker_statistics']},
				// Optional styling:
				// gridLineWidth: 1
			},
			{
				title: { text: translations?.['ref__sales_statistics'] + ' (%)' },
				opposite: true // puts the axis on the right side
				// gridLineWidth: 0 // optional: hide grid for the right axis
			}
		],
		series: [],
		credits: {
			enabled: false
		}
	})

	const [
		dateConsignationShowModal,
		dateConsignationOpenDateModalHandler,
		dateConsignationRenderModal,
		dateConsignationStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(15, 'days').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate()
	})
	const actionsStatistics = bindActionCreators(statisticsActionCreators, useDispatch())
	const [stateDefaultValues, setStateDefaultValues] = useState({
		selectedKiosk: null,
	})

	const { register, handleSubmit, setValue, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	const handleFormSubmit = (data) => {
		setCurrentKiosk({ kioskId: data.kiosk})
		actionsStatistics.getStatistics(data.kiosk, dateConsignationStateDate.date.startDate, dateConsignationStateDate.date.endDate)
	}

	const handleExportData = (data) => {
		actionsStatistics.exportStatistics()
	}

	// USE EFFECTS

	useEffect(() => {
		return function cleanUp() {
			actionsStatistics.resetStatistics()
		}
	}, [])

	useEffect(() => {
		if (dateConsignationStateDate.showModal && currentKiosk.kioskId) {
			actionsStatistics.getStatistics(currentKiosk.kioskId, dateConsignationStateDate.date.startDate, dateConsignationStateDate.date.endDate)
		}
	}, [dateConsignationShowModal])

	useEffect(() => {
		// Sales chart
		setSalesOptions(prev => ({
			...prev,
			series: [
				{ name: translations['ref__sales_chart_statistics'], data : [{ name: translations['ref__sales_valid_statistics'], y: 100 - statistics?.cancelledSales ?? 0 }, { name: translations['ref__sales_cancelled_statistics'], y: statistics?.cancelledSales ?? 0 }]},
			]
		}))

		// VoltageChart
		setAverageVoltageOptions(prev => ({
			...prev,
			xAxis: { ...prev.xAxis, type: 'datetime' },
			series: [
				// left axis
				...Object.entries(statistics?.averageVoltageData ?? {})
					.filter(([k]) => !k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k,
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(p => [toUTC(p.date), p.value]),
						type: 'line',
						yAxis: 0
					})),
				// right axis
				...Object.entries(statistics?.averageVoltageData ?? {})
					.filter(([k]) => k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k,
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(p => [toUTC(p.date), p.value]),
						type: 'line',
						yAxis: 1
					}))
			]
		}));

		// VoltageChart
		setMinVoltageOptions(prev => ({
			...prev,
			xAxis: { ...prev.xAxis, type: 'datetime' },
			series: [
				...Object.entries(statistics?.minVoltageData ?? {})
					.filter(([k]) => !k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
					name: translations?.[k] ?? k, // fallback if missing translation
					data: arr
						.slice()
						.sort((a, b) => a.date.localeCompare(b.date))
						.map(point => [toUTC(point.date), point.value]),
					type: 'line',
					yAxis: 0
				})),
				...Object.entries(statistics?.minVoltageData ?? {})
					.filter(([k]) => k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k, // fallback if missing translation
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(point => [toUTC(point.date), point.value]),
						type: 'line',
						yAxis: 1
					}))
			]
		}));

		// VoltageChart
		setMaxVoltageOptions(prev => ({
			...prev,
			xAxis: { ...prev.xAxis, type: 'datetime' },
			series: [
				...Object.entries(statistics?.maxVoltageData ?? {})
					.filter(([k]) => !k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k, // fallback if missing translation
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(point => [toUTC(point.date), point.value]),
						type: 'line',
						yAxis: 0
				})),
				...Object.entries(statistics?.maxVoltageData ?? {})
					.filter(([k]) => k.startsWith('ref__filter_solar_panel_statistics'))
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k, // fallback if missing translation
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(point => [toUTC(point.date), point.value]),
						type: 'line',
						yAxis: 1
				})),
			]
		}));

		// Bottle data
		setBottleOptions(prev => ({
			...prev,
			xAxis: { ...prev.xAxis, type: 'datetime' },
			series: [
				...Object.entries(statistics?.bottlesData ?? {})
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k, // fallback if missing translation
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(point => [toUTC(point.date), point.value]),
						type: 'line',
						yAxis: 0
					})),
				...Object.entries(statistics?.validSalesData ?? {})
					.map(([k, arr]) => ({
						name: translations?.[k] ?? k, // fallback if missing translation
						data: arr
							.slice()
							.sort((a, b) => a.date.localeCompare(b.date))
							.map(point => [toUTC(point.date), point.value]),
						type: 'line',
						yAxis: 1
					}))
			]
		}));
	}, [statistics])

	// RENDERING

	return (
		<StatisticsWrapper>
			{dateConsignationRenderModal()}
			<LeftPartWrapper>
				<KioskDataWrapper>
					<h2>{statistics?.kioskName ?? 'N/A'}</h2>
					<FiltersWrapper>
						<form onSubmit={handleSubmit(handleFormSubmit)}>
							<Dropdown
								zeroValue={translations['ref__select_kiosk_statistics']}
								listName={'kiosk'}
								list={
									userKioskPerimeter
										? userKioskPerimeter.map((kiosk) => ({
												id: kiosk.id,
												label: kiosk.store,
												value: kiosk.id,
										  }))
										: []
								}
								register={register}
								onChangeHandler={handleSubmit(handleFormSubmit)}
							></Dropdown>
						</form>
						<CalendarWrapper>
							<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
								{translations['ref__date_statistics'] + ' :'}
							</label>
							<DatePickerTransactionIcon onClick={dateConsignationOpenDateModalHandler} />
							<DatePickerFilterLabel>
								<span>
									{translations['page__global__admin__header_datePicker_from']}{' '}
									{moment(dateConsignationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
								</span>
								<span>
									{translations['page__global__admin__header_datePicker_to']}{' '}
									{moment(dateConsignationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
								</span>
							</DatePickerFilterLabel>

						</CalendarWrapper>
					</FiltersWrapper>
					<p> {translations['ref__last_autodiag_statistics']} : {
						statistics?.lastDiagDate ? moment(statistics?.lastDiagDate).format('DD/MM/YYYY HH:mm') : 'N/A'
					}</p>
					<p> {translations['ref__last_sale_statistics']} : {
						statistics?.lastSale ? moment(statistics?.lastSale).format('DD/MM/YYYY HH:mm') :  'N/A'
					} </p>
				</KioskDataWrapper>
				<SalesChartsWrapper>
					<HighchartsReact highcharts={Highcharts} options={salesOptions} />
				</SalesChartsWrapper>
			</LeftPartWrapper>
			<LineChartsWrapper>
				<ChartsContainer>
					<ChartsWrapper>
						<HighchartsReact highcharts={Highcharts} options={averageVoltageOptions}/>
					</ChartsWrapper>
					<ChartsWrapper>
						<HighchartsReact highcharts={Highcharts} options={minVoltageOptions}/>
					</ChartsWrapper>
					<ChartsWrapper>
						<HighchartsReact highcharts={Highcharts} options={maxVoltageOptions}/>
					</ChartsWrapper>
					<ChartsWrapper>
						<HighchartsReact highcharts={Highcharts} options={bottleOptions} />
					</ChartsWrapper>
				</ChartsContainer>
			</LineChartsWrapper>
			<ExportWrapper>
				<Tooltip translationsKey={'tooltip__admin__global__export__data'} tooltipId={'tableExportData'} position={'left'}>
					<ExportButton src={Export} onClick={() => handleExportData()} />
				</Tooltip>
			</ExportWrapper>
		</StatisticsWrapper>
	)
}

Statistics.propTypes = {}

Statistics.defaultPropTypes = {}

export default Statistics